import React from "react";
import { Typography, Tag } from "antd";
import card1Image from "../../assets/images/card1Image.avif"
import card2Image from "../../assets/images/card2Image.avif"
import card3Image from "../../assets/images/card3Image.avif"
import card4Image from "../../assets/images/card4Image.avif"


const SECTIONS = [
  {
    id: 1,
    tag: "ACCESS COMPANIES",
    tagColor: "#FACC15",
    title: "Get Referrals",
    description:
      "Boost your job prospects with referrals from our vast network of companies.",
    image: card1Image ,
  },
  {
    id: 2,
    tag: "TAILORED INTERVIEW PREP",
    tagColor: "#3B82F6",
    title: "Company-Specific Prep",
    description:
      "Get ready for interviews with customized preparation for your target companies.",
    image: card2Image,
  },
  {
    id: 3,
    tag: "INTERACTIVE CODING SESSIONS",
    tagColor: "#8B5CF6",
    title: "Live Coding Practice",
    description:
      "Improve your skills with live coding exercises and real-time feedback.",
    image: card3Image,
  },
  {
    id: 4,
    tag: "LIFETIME PLACEMENT ASSISTANCE",
    tagColor: "#10B981",
    title: "Career Support",
    description:
      "Continue to receive job opportunities and support as a valued alumnus of Pronttera Labs.",
    image: card4Image,
  },
];

export default function OutcomePowerhouse() {
  return (
    <section className="containerLayout py-10 bg-[#F9FAFB] section">
      <div className="py-10 text-center">
        <Typography.Text className="text-gray-500 uppercase">
          Welcome to the Outcome Powerhouse
        </Typography.Text>
        <Typography.Title className="text-[#1E3A8A]">
          Your Recipe for a Rockstar Career
        </Typography.Title>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {SECTIONS.map((section) => (
          <div key={section.id} className="p-6 bg-white rounded-2xl shadow-lg flex flex-col md:flex-row border border-gray-200">
            <div className="flex-1">
              <Tag color={section.tagColor} className="mb-2 text-white px-3 py-1 rounded-md font-medium">
                {section.tag}
              </Tag>
              <Typography.Title level={4} className="text-[#1E3A8A]">{section.title}</Typography.Title>
              <Typography.Text className="text-gray-600">{section.description}</Typography.Text>
            </div>
            <img
              src={section.image}
              alt={section.title}
              className="w-32 h-32 object-cover rounded-md ml-4"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
